class PermissionGroup {
	constructor(callback, id, title) {
		this._callback = callback;
		this._id = id;
		this._title = title;
		this._total = span();
		this._checks = [];
		this._permissions = [];
	}

	add(id, labelText) {
		let check = UI.chk(id, {
			'change': (ev) => {
				this._callback.change(id, ev.target.checked);
			}
		}, {
			'id': 'permission-check-' + id
		});
		this._checks.push(check);
		this._permissions.push(
			UI.div('', [
				check,
				UI.label(labelText, null, {
					'for': 'permission-check-' + id
				})
			]
		));
	}

	init(setValue) {
		this._checks.forEach(chk => chk.checked = chk.value & setValue);
		this.total();
	}

	total() {
		let count = 0;
		this._checks.forEach(chk => {if (chk.checked) count++});
		this._total.innerHTML = count + " of " + this._permissions.length;
	}

	change(id, cb) {
		this.total();
		this._callback.change(id, cb);
	}

	elem() {
		return UI.div('accordion-item', [
			htm('h2', 'accordion-header', [
				btn('accordion-button collapsed', this._title, null, {
					'data-bs-toggle': 'collapse',
					'data-bs-target': '#permissions-accordion-'+this._id,
					'aria-expanded': 'false',
					'aria-controls': 'permissions-accordion-'+this._id
				})
			]),
			div('accordion-collapse collapse', [
				div('accordion-body container-flush', this._permissions)
			], null, {
				'id': 'permissions-accordion-'+this._id,
				'data-bs-parent': '#permissions-accordion'
			})
		]);
	}
}